export const SIGNUP_ROOT_ROUTE = 'SignUp'

export const subRoutes = {
  locationDetails: `/location-details`,
  contactDetails: `/contact-details`,
  verification: `/verification`,
  password: `/password`,
  phoneNumberVerification: `/phone-number-verification`,
  security: `/security`,
  depositLimit: `/deposit-limit`,
  signUpUnsuccessful: `/unsuccessful`,
  signUpComplete: `/complete`,
  verificationAccountInformation: '/verification-account/information',
} as const

const withRoot = (path: string) => `/${SIGNUP_ROOT_ROUTE}${path}`
export const routes = {
  any: withRoot('/*'),
  personalDetails: `/${SIGNUP_ROOT_ROUTE}`,
  locationDetails: withRoot(subRoutes.locationDetails),
  contactDetails: withRoot(subRoutes.contactDetails),
  verification: withRoot(subRoutes.verification),
  password: withRoot(subRoutes.password),
  phoneNumberVerification: withRoot(subRoutes.phoneNumberVerification),
  security: withRoot(subRoutes.security),
  depositLimit: withRoot(subRoutes.depositLimit),
  signUpUnsuccessful: withRoot(subRoutes.signUpUnsuccessful),
  signUpComplete: withRoot(subRoutes.signUpComplete),
  verificationAccountInformation: withRoot(subRoutes.verificationAccountInformation),
  home: `/`,
} as const
